// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"60ef11f8","815":"796eb769","831":"88aaef60","875":"f2eed556"}[chunkId] + ".chunk.js";
};